import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as jwt_decode from 'jwt-decode';
import { BehaviorSubject, Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { environment } from 'src/environments/environment';
import { isNullOrUndefined } from 'util';

import { Cliente } from '../models/cliente';
import { PersonaNatural } from '../models/persona-natural';
import { UserLogin } from '../models/userLogin';


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable(({
    providedIn: 'root'
}))
export class PerfilService {
    public idRut: any;
    public idPregunta: any;
    public datosRecovery: { 'Rut': string; 'IdPregunta': number; 'Pregunta': string; };
    private dataClienteSource = new BehaviorSubject<any>(null);
    public dataCliente$ = this.dataClienteSource.asObservable();

    constructor(private auth: AuthenticationService,private httpClient: HttpClient) { }

    getClientes(pIdCliente: any = 0, pIdUnidad: any = 0, pIdAplicacion: any = 0) {
        return new Observable(resolve => {
            console.log(`${environment.api_baseurl_ecc_socios}/api/Clientes`);
            let url = `${environment.api_baseurl_ecc_socios}/api/Clientes/`;
            url += `idUnidad=${pIdUnidad}&idCliente=${pIdCliente}&idAplicacion=${pIdAplicacion}`;
            this.httpClient.get(url).subscribe(
                response => {
                    if (response['codigo'] === 1) {
                        // se agrega para que notifique la data del usuario que ha iniciado sesión
                        this.setDataCliente(response['data']);
                    } else {
                        this.setDataCliente(null);
                    }
                    resolve.next(response);
                    resolve.complete();
                },
                error => {
                    // this.auth.logout();
                });
        });
    }

    getPuntosCategoriaCliente(pIdCliente: any, pIdUnidad: any) {
        console.log(`${environment.api_baseurl_ecc_socios}/api/CategoriasCliente/GetPuntos`);
        // tslint:disable-next-line: max-line-length
        return this.httpClient.get(`${environment.api_baseurl_ecc_socios}/api/CategoriasCliente/GetPuntos?idUnidad=` + pIdUnidad + `&idCliente=` + pIdCliente);
    }

    getCambioCategoriaCliente(pIdCliente: any, pIdUnidad: any) {
        console.log(`${environment.api_baseurl_ecc_socios}/api/CategoriasCliente/GetCambioCategoria`);
        // tslint:disable-next-line: max-line-length
        return this.httpClient.get(`${environment.api_baseurl_ecc_socios}/api/CategoriasCliente/GetCambioCategoria?idUnidad=` + pIdUnidad + `&idCliente=` + pIdCliente);
    }

    setDataCliente(value) {
        this.dataClienteSource.next(value);
    }

    getDataCliente() {
        return this.dataClienteSource.asObservable();
    }

    setEnrolarCliente(params: any) {
        return this.httpClient.post(`${environment.api_baseurl_ecc_socios}/api/Clientes/SetCliente`, params, httpOptions);
    }

    updCliente(pCliente: Cliente) {
        console.log('idCliente: ' + pCliente['idCliente']);
        console.log('mail: ' + pCliente['email']);
        console.log('celu: ' + pCliente['celular']);
        console.log(`${environment.api_baseurl_ecc_socios}/api/Clientes/ActualizarCliente`);

        const params = {
            // tslint:disable-next-line: radix
            'IdCliente': parseInt(pCliente['idCliente'].toString()),
            'Email': pCliente['email'],
            'Celular': pCliente['celular']
        };

        return this.httpClient.put(`${environment.api_baseurl_ecc_socios}/api/Clientes/ActualizarCliente`, params, httpOptions);

    }

    getPaises() {
        return this.httpClient.get(`${environment.api_baseurl_ecc_transversal}/api/pais`);
    }
    getListadoCasinos() {
        return this.httpClient.get(`${environment.api_baseurl_ecc_socios}/api/unidades`);
    }

    changePassword(objetoUserLogin: UserLogin) {
        console.log(objetoUserLogin);
        let url = `${environment.api_baseurl_ecc_transversal}/api/RecuperacionPass/SetUpdPassCliente`;
        url += `?pRut=${objetoUserLogin.rut}`;
        url += `&pPass=${objetoUserLogin.password}`;
        url += `&pNewPass=${objetoUserLogin.newPassword}`;
        url += `&pIdPregunta=${objetoUserLogin.idPregunta}`;
        url += `&pRespuesta=${objetoUserLogin.respuesta}`;
        // const httpOpts = JSON.parse(JSON.stringify(httpOptions));
        // httpOpts.params = params;
        return this.httpClient.put(url, httpOptions);
    }

    recoveryPassword(objetoUserLogin: UserLogin) {
        // tslint:disable-next-line: max-line-length
        return this.httpClient.put(`${environment.api_baseurl_ecc_transversal}/api/RecuperacionPass/SetResetPassCliente?pRut=${objetoUserLogin.rut}pPass=${objetoUserLogin.password}&pIdPregunta=${objetoUserLogin.idPregunta}&pRespuesta=${objetoUserLogin.respuesta}`, httpOptions);

    }

    GetPreguntasSeguridad() {
        return this.httpClient.get(`${environment.api_baseurl_ecc_transversal}/api/RecuperacionPass/GetPreguntasSeguridad`);
    }

    validaRespuesta(objetoUserLogin: UserLogin) {
        // tslint:disable-next-line: max-line-length
        return this.httpClient.get(`${environment.api_baseurl_ecc_transversal}/api/RecuperacionPass/GetValidaRespuestaCliente?pRut=${objetoUserLogin.rut}&pIdPregunta=${objetoUserLogin.idPregunta}&pRespuesta=${objetoUserLogin.respuesta}`);
    }

    getPreguntaUsuario(rut: any) {
        return this.httpClient.get(`${environment.api_baseurl_ecc_transversal}/api/RecuperacionPass/GetPreguntaCliente?pRut=` + rut);

    }

    setRut(idrutUsuario: any) {
        this.idRut = idrutUsuario;
    }

    getRut() {
        return this.idRut;
    }

    getDatosClienteRecovery() {
        return this.datosRecovery;
    }

    setDatosClienteRecovery(rut: any, idPregunta: any, pregunta: any) {
        this.datosRecovery = {
            'Rut': rut,
            'IdPregunta': idPregunta,
            'Pregunta': pregunta
        };
    }

    getPuntosPorVencer(idCliente) {
        return this.httpClient.get(`${environment.api_baseurl_ecc_socios}/api/Clientes/GetObtenerCartola?pIdCliente=` + idCliente);
    }

    obtenerUsuarioVerificado(): PersonaNatural {
        const personaNatural = new PersonaNatural();
        let token: any = null;
        const tokenStorage: string = localStorage.getItem('auth.authToken');
        if (!isNullOrUndefined(tokenStorage)) {
            token = jwt_decode(tokenStorage);
            personaNatural.idUsuario = token.sub.split(('-'), [1])[0];
            personaNatural.idUnidad = token.codigoUnidad;
        }
        return personaNatural;
    }

    public saveLocalizacion(latitud: any, longitud: any) {
        console.log(latitud);
        localStorage.setItem('location.latitud', latitud);
        localStorage.setItem('location.longitud', longitud);
        return true;

    }
    public getLocalizacion() {
        return { latitud: localStorage.getItem('location.latitud'), longitud: localStorage.getItem('location.longitud') };
    }


    upload_profile_picture(idCliente: any, imagebase64: any) {
        const url = `${environment.api_baseurl_ecc_socios}/api/clientes/EstablecerPerfilImagen`;
        const options = {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        };
        const body = { idCliente: idCliente, contenido: imagebase64 };
        console.log(JSON.stringify(body));

        return this.httpClient.post(url, JSON.stringify(body), options);
    }

    /**
      * regresa imagen perfil del cliente
      * @param pIdCliente
      */
    get_profile_picture(idCliente) {
        const url = `${environment.api_baseurl_ecc_socios}/api/clientes/LeerPerfilImagen/` + idCliente;
        return this.httpClient.get(url).pipe(shareReplay(1));
    }
}
